const dashboardTemplate = require("./dashboard.html.slim");
declare var angular;

export class TwoFactorAuthDashboard {
  static $inject = ['$rootScope', '$scope', 'users', '$location', 'brand'];

  twoFactorEnabled: boolean;
  twoFactorInfo: any;
  deviceList: any[];
  currentDevice: boolean;
  state: string;
  brandFullName: string;
  error: string;
  isBetaUser: boolean;
  showLegacyTwoFactor: any;
  stateLoaded = false;

  constructor(
    public $rootScope,
    public $scope,
    public users,
    public $location,
    public brand,
  ) {
    Promise.all([this.getIsMigrated(), this.updateDeviceList()])
      .finally(() => this.stateLoaded = true)

    this.brandFullName = this.brand.getBrandFullName();

    $rootScope.$on("update_tfa_dashboard", () => {
      this.updateDeviceList();
    });
  }

  getIsMigrated() {
    return this.users.isMigrated(this.users.getCurrentUser().email)
      .then(() => this.showLegacyTwoFactor = false)
      .catch(() => this.showLegacyTwoFactor = true);
  }

  enableTwoFactor(method) {
    this.$rootScope.$broadcast('enableTwoFactor', {
      tfaMethod: method,
      phone: this.twoFactorInfo.phone || this.twoFactorInfo.phoneNumber
    });
  }

  disableTwoFactor(method) {
    this.$rootScope.$broadcast('disableTwoFactor', {tfaMethod: method});
  }

  updateTwoFactor() {
    this.$rootScope.$broadcast('updateTwoFactor', {tfaInfo: this.twoFactorInfo});
  }

  updateDeviceList() {
    this.currentDevice = false;
    this.users.twoFactorInfo()
      .then((resp) => {
        this.state = '';
        if (this.twoFactorEnabled = resp.twoFactorEnabled) {
          this.findCurrentDevice(this.deviceList = resp.deviceList);
          this.twoFactorInfo = resp.twoFactorInfo;
          if (this.$location.search().editphone) this.updateTwoFactor();
        } else {
          this.twoFactorInfo = resp;
        };
      })
      .catch((error) => {
        this.state = 'error';
        this.error = error.data.message;
      });
  }

  findCurrentDevice(list) {
    list.forEach((device) => {
      let currentDevice = device.properties.currentDevice;
      if (currentDevice) { this.currentDevice = currentDevice;};
    });
  }
}

angular.module("wbComponents").directive("twoFactorAuthDashboard", function() {
  return {
    restrict: "E",
    templateUrl: dashboardTemplate,
    controller: TwoFactorAuthDashboard,
    controllerAs: 'tfa',
    bindToController: true
  };
});
